import PreviewExpandable from 'app/features/questionnaires/components/PreviewExpandable';
import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../routes/slice';

import PreviewAutomobiles from './Automobiles/preview';
import PreviewHomeOffice from './HomeOffice/preview';
import PreviewBookKeeping from './BookKeeping/preview';
import PreviewCompensation from './Compensation/preview';
import PreviewBalanceSheet from './BalanceSheet/preview';
import PreviewProfitandLossStatement from './ProfitandLossStatement/preview';
import PreviewRentalActivity from './RentalActivity/preview';
import PreviewSpecialDeductionsInformation from './SpecialDeductionsInformation/preview';
import PreviewPaycheckProtectionProgramPPP from './PaycheckProtectionProgramPPP/preview';
import PreviewMiscellaneousInformation from './MiscellaneousInformation/preview';

export interface IPreviewAdditionalQuestionsProps {}

export default function PreviewAdditionalQuestions(
  props: IPreviewAdditionalQuestionsProps,
) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <PreviewExpandable title="Additional Questions">
        {routes.additionalQuestions.automobiles && <PreviewAutomobiles />}
        {routes.additionalQuestions.homeOffice && <PreviewHomeOffice />}
        {routes.additionalQuestions.bookKeeping && <PreviewBookKeeping />}
        {routes.additionalQuestions.compensation && <PreviewCompensation />}
        {routes.additionalQuestions.balanceSheet && <PreviewBalanceSheet />}
        {routes.additionalQuestions.profitandLossStatement && (
          <PreviewProfitandLossStatement />
        )}
        {routes.additionalQuestions.rentalActivity && <PreviewRentalActivity />}
        {routes.additionalQuestions.specialDeductionsInformation && (
          <PreviewSpecialDeductionsInformation />
        )}
        {routes.additionalQuestions.paycheckProtectionProgramPPP && (
          <PreviewPaycheckProtectionProgramPPP />
        )}
        {routes.additionalQuestions.miscellaneousInformation && (
          <PreviewMiscellaneousInformation />
        )}
      </PreviewExpandable>
    </>
  );
}
